import _regeneratorRuntime from "@babel/runtime/regenerator";
import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import { Integrations as ApmIntegrations } from "@sentry/apm";
import * as Sentry from "@sentry/browser";
import * as React from "react";
import { positions, Provider as AlertProvider } from "react-alert";
import { render } from "react-dom";
import TagManager from "react-gtm-module";
import { hot } from "react-hot-loader";
import { Route, Router } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import { QueryParamProvider } from "use-query-params";
import { NotificationTemplate } from "@components/atoms";
import { ServiceWorkerProvider } from "@components/containers";
import { SaleorProvider } from "@saleor/sdk";
import { defaultTheme, GlobalStyle } from "@styles";
import { App } from "./app";
import { LocaleProvider } from "./components/Locale";
import { apiUrl, sentryDsn, sentrySampleRate, serviceWorkerTimeout } from "./constants";
import { history } from "./history";
var SALEOR_CONFIG = {
  apiUrl: apiUrl
};

if (process.env.GTM_ID !== undefined) {
  TagManager.initialize({
    gtmId: process.env.GTM_ID
  });
}

var startApp =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    var notificationOptions, Root;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (sentryDsn !== undefined) {
              Sentry.init({
                dsn: sentryDsn,
                integrations: [new ApmIntegrations.Tracing()],
                tracesSampleRate: sentrySampleRate
              });
            }

            notificationOptions = {
              position: positions.BOTTOM_RIGHT,
              timeout: 2500
            };
            Root = hot(module)(function () {
              return React.createElement(Router, {
                history: history
              }, React.createElement(QueryParamProvider, {
                ReactRouterRoute: Route
              }, React.createElement(SaleorProvider, {
                config: SALEOR_CONFIG
              }, React.createElement(App, null))));
            });
            render(React.createElement(ThemeProvider, {
              theme: defaultTheme
            }, React.createElement(AlertProvider, _extends({
              template: NotificationTemplate
            }, notificationOptions), React.createElement(ServiceWorkerProvider, {
              timeout: serviceWorkerTimeout
            }, React.createElement(LocaleProvider, null, React.createElement(GlobalStyle, null), React.createElement(Root, null))))), document.getElementById("root")); // Hot Module Replacement API

            if (module.hot) {
              module.hot.accept();
            }

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function startApp() {
    return _ref.apply(this, arguments);
  };
}();

startApp();